const LOGO_URL = "https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/0245c007cf03e632cb0ef6dc8c6831b5.png";
const WHATSAPP_URL = "https://wa.me/5547996077227";

const navLinks = [
  { label: "Sobre", href: "#sobre" },
  { label: "Áreas", href: "#areas" },
  { label: "Diferenciais", href: "#diferenciais" },
  { label: "Contato", href: "#contato" },
];

const areas = [
  "Direito Médico",
  "Direito à Saúde",
  "Direito Previdenciário",
  "Direito de Família",
  "Direito Trabalhista",
  "Direito Civil",
];

const handleNav = (href: string) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function Footer() {
  return (
    <footer style={{ background: "linear-gradient(135deg, #071a55, #0A2472)" }}>
      {/* Gold top border */}
      <div className="w-full h-px" style={{ background: "linear-gradient(90deg, transparent, #C8A63A, #E6D18A, #C8A63A, transparent)" }} />

      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="QM Advocacia" className="h-14 w-auto object-contain mb-5" />
            <p className="text-white/60 text-sm leading-relaxed max-w-xs mb-6" style={{ fontFamily: "'Inter', sans-serif" }}>
              Advocacia de excelência, célere e eficiente. Protegendo direitos fundamentais como vida, saúde, patrimônio e trabalho em Joinville/SC.
            </p>
            <div className="flex gap-3">
              {[
                { icon: "ri-instagram-line", href: "https://www.instagram.com/qmanske" },
                { icon: "ri-facebook-line", href: "https://www.facebook.com/quelenbeatriz.crizelmanske" },
                { icon: "ri-whatsapp-line", href: WHATSAPP_URL },
              ].map((s) => (
                <a
                  key={s.href}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 flex items-center justify-center rounded-md border border-white/10 text-white/50 hover:border-[#C8A63A]/60 hover:text-[#E6D18A] transition-all duration-300 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5 className="font-bold text-white text-sm mb-5 uppercase tracking-wide" style={{ fontFamily: "'Inter', sans-serif" }}>
              Navegação
            </h5>
            <ul className="space-y-3">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    onClick={(e) => { e.preventDefault(); handleNav(link.href); }}
                    className="text-white/55 text-sm hover:text-[#E6D18A] transition-colors duration-300 cursor-pointer flex items-center gap-2"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <i className="ri-arrow-right-s-line text-xs text-[#C8A63A]" />
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Areas */}
          <div>
            <h5 className="font-bold text-white text-sm mb-5 uppercase tracking-wide" style={{ fontFamily: "'Inter', sans-serif" }}>
              Áreas de Atuação
            </h5>
            <ul className="space-y-3">
              {areas.map((area) => (
                <li key={area}>
                  <a
                    href="#areas"
                    onClick={(e) => { e.preventDefault(); handleNav("#areas"); }}
                    className="text-white/55 text-sm hover:text-[#E6D18A] transition-colors duration-300 cursor-pointer flex items-center gap-2"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <i className="ri-arrow-right-s-line text-xs text-[#C8A63A]" />
                    {area}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs text-center" style={{ fontFamily: "'Inter', sans-serif" }}>
            © {new Date().getFullYear()} Quelen Manske Sociedade Individual de Advocacia – CNPJ: 32.043.949/0001-65. Todos os direitos reservados.
          </p>
          <a
            href="https://startdigital1.com.br/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="text-white/30 text-xs text-center hover:text-[#E6D18A] transition-colors duration-300 cursor-pointer whitespace-nowrap"
            style={{ fontFamily: "'Inter', sans-serif" }}
          >
            Desenvolvido por Start Digital
          </a>
        </div>
      </div>
    </footer>
  );
}
